export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  rating: number;
  status: '完结' | '连载中';
  description: string;
  chapters: { number: number; title: string; date: string }[];
  tags: string[];
  views: number;
  updateDate: string;
}

export const allComics: Comic[] = [
  {
    id: 1,
    title: '女神降临',
    author: '猫咪作家',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20with%20makeup%20transformation%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20clean%20line%20art%20style%2C%20pastel%20color%20palette%2C%20simple%20background%20with%20gradient%2C%20elegant%20and%20charming%20portrait%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 4.9,
    status: '连载中',
    description: '讲述了一个通过化妆技巧改变外貌的女孩，在校园里展开的浪漫爱情故事。女主角任晶晶通过化妆从丑小鸭变成了白天鹅，却在这个过程中发现了真正的自我价值和爱情的真谛。这部漫画以精致的画风和感人至深的剧情获得了广大读者的喜爱。',
    chapters: [
      { number: 1, title: '新的开始', date: '2025-01-15' },
      { number: 2, title: '化妆的力量', date: '2025-01-22' },
      { number: 3, title: '校园邂逅', date: '2025-01-29' },
      { number: 4, title: '秘密被发现', date: '2025-02-05' },
      { number: 5, title: '真实的自己', date: '2025-02-12' },
      { number: 6, title: '心跳加速', date: '2025-02-19' },
      { number: 7, title: '意外的约会', date: '2025-02-26' },
      { number: 8, title: '朋友还是恋人', date: '2025-03-05' },
      { number: 9, title: '化妆品的秘密', date: '2025-03-12' },
      { number: 10, title: '新的挑战者', date: '2025-03-19' },
    ],
    tags: ['恋爱', '校园', '化妆', '变身'],
    views: 1280000,
    updateDate: '2025-03-19',
  },
  {
    id: 2,
    title: '我独自升级',
    author: '张韩光',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20dark%20fantasy%20illustration%20of%20a%20powerful%20male%20warrior%20with%20glowing%20eyes%2C%20surrounded%20by%20shadow%20soldiers%2C%20dramatic%20lighting%20with%20dark%20background%2C%20epic%20battle%20atmosphere%2C%20detailed%20illustration%20with%20strong%20contrast%2C%20clean%20manhwa%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 4.8,
    status: '完结',
    description: '在充满怪物的世界里，最弱猎人成肖宇在一次生死考验中获得了独一无二的"升级系统"。从此，他从最底层一步步成长为最强的猎人。这部漫画以其宏大的世界观和紧凑的剧情节奏，成为了韩国漫画界现象级的作品。',
    chapters: [
      { number: 1, title: '最弱的猎人', date: '2024-08-10' },
      { number: 2, title: '双重 dungeon', date: '2024-08-17' },
      { number: 3, title: '系统激活', date: '2024-08-24' },
      { number: 4, title: '每日任务', date: '2024-08-31' },
      { number: 5, title: '第一次升级', date: '2024-09-07' },
      { number: 6, title: '隐藏副本', date: '2024-09-14' },
      { number: 7, title: '新能力觉醒', date: '2024-09-21' },
      { number: 8, title: '地下城突袭', date: '2024-09-28' },
      { number: 9, title: '暗影军团', date: '2024-10-05' },
      { number: 10, title: '觉醒的力量', date: '2024-10-12' },
    ],
    tags: ['动作', '奇幻', '升级', '战斗'],
    views: 2560000,
    updateDate: '2024-10-12',
  },
  {
    id: 3,
    title: '甜蜜的谎言',
    author: '金秀雅',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20illustration%20of%20a%20couple%20standing%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20gentle%20spring%20atmosphere%2C%20sweet%20romantic%20mood%2C%20clean%20modern%20manhwa%20art%20style%2C%20simple%20dreamy%20background%2C%20emotional%20portrait%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    status: '连载中',
    description: '为了逃避家族安排的婚姻，财阀千金冒充普通上班族进入了一家小公司。在这里，她遇到了一个看似普通却暗藏秘密的男人。一场甜蜜的谎言，一段真假难辨的爱情。当所有真相浮出水面，他们还能回到最初的心动吗？',
    chapters: [
      { number: 1, title: '逃婚计划', date: '2025-02-01' },
      { number: 2, title: '新身份', date: '2025-02-08' },
      { number: 3, title: '第一天上班', date: '2025-02-15' },
      { number: 4, title: '隔壁的他', date: '2025-02-22' },
      { number: 5, title: '意外的午餐', date: '2025-03-01' },
      { number: 6, title: '秘密任务', date: '2025-03-08' },
      { number: 7, title: '家族追查', date: '2025-03-15' },
      { number: 8, title: '心动时刻', date: '2025-03-22' },
    ],
    tags: ['恋爱', '职场', '财阀', '喜剧'],
    views: 890000,
    updateDate: '2025-03-22',
  },
  {
    id: 4,
    title: '剑与魔法',
    author: '李玄宇',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20illustration%20of%20a%20magic%20swordsman%20in%20a%20mystical%20world%2C%20glowing%20sword%20with%20magical%20runes%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20detailed%20fantasy%20manhwa%20art%20style%2C%20ethereal%20blue%20and%20gold%20energy%2C%20clean%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 4.6,
    status: '连载中',
    description: '在一个魔法与剑并存的世界里，出身平凡的少年偶然获得了一把传说中的魔剑。从此他踏上了成为最强魔法剑士的旅程。宏大的世界观、精彩的战斗场面和深刻的角色刻画，让这部作品成为了奇幻漫画中的经典之作。',
    chapters: [
      { number: 1, title: '命运之剑', date: '2025-01-20' },
      { number: 2, title: '魔法学院', date: '2025-01-27' },
      { number: 3, title: '第一次试炼', date: '2025-02-03' },
      { number: 4, title: '剑术大师', date: '2025-02-10' },
      { number: 5, title: '暗影来袭', date: '2025-02-17' },
      { number: 6, title: '团队集结', date: '2025-02-24' },
      { number: 7, title: '远古遗迹', date: '2025-03-03' },
      { number: 8, title: '觉醒之力', date: '2025-03-10' },
    ],
    tags: ['奇幻', '冒险', '魔法', '剑术'],
    views: 750000,
    updateDate: '2025-03-10',
  },
  {
    id: 5,
    title: '办公室喜剧人',
    author: '朴智恩',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20humorous%20Korean%20webtoon%20illustration%20of%20funny%20office%20workers%20in%20comedic%20situations%2C%20bright%20and%20colorful%20art%20style%2C%20exaggerated%20expressions%2C%20cheerful%20office%20background%2C%20light%20hearted%20comedy%20mood%2C%20clean%20cartoon%20style%2C%20warm%20color%20palette&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 4.5,
    status: '连载中',
    description: '一个永远在摸鱼的员工，一个工作狂老板，一群奇葩同事，在平凡的公司里上演不平凡的日常。每集都能让你捧腹大笑，在忙碌的生活中找到一丝轻松和快乐。这部韩国漫画用幽默的笔触描绘了现代职场人的酸甜苦辣。',
    chapters: [
      { number: 1, title: '面试风云', date: '2025-03-01' },
      { number: 2, title: '上班第一天', date: '2025-03-08' },
      { number: 3, title: '午餐大作战', date: '2025-03-15' },
      { number: 4, title: '会议马拉松', date: '2025-03-22' },
      { number: 5, title: '加班夜未眠', date: '2025-03-29' },
      { number: 6, title: '团建大逃杀', date: '2025-04-05' },
    ],
    tags: ['搞笑', '职场', '日常', '治愈'],
    views: 620000,
    updateDate: '2025-04-05',
  },
  {
    id: 6,
    title: '真相追踪',
    author: '崔刑警',
    category: 'suspense',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20webtoon%20illustration%20with%20a%20detective%20character%20in%20a%20dark%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20suspenseful%20mood%2C%20rainy%20night%20scene%2C%20clean%20manhwa%20line%20art%20with%20strong%20contrast%2C%20mysterious%20and%20tense%20visuals&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 4.4,
    status: '连载中',
    description: '前刑警朴正宇在追查一起未解的连环案件时，发现了一个隐藏在韩国社会深处的巨大阴谋。每个线索都指向一个更大的真相。紧张刺激的剧情，错综复杂的人物关系，让你欲罢不能。这是一部让你一打开就停不下来的悬疑韩漫。',
    chapters: [
      { number: 1, title: '失踪的少女', date: '2025-02-10' },
      { number: 2, title: '第一条线索', date: '2025-02-17' },
      { number: 3, title: '目击者', date: '2025-02-24' },
      { number: 4, title: '地下世界', date: '2025-03-03' },
      { number: 5, title: '嫌疑人的秘密', date: '2025-03-10' },
      { number: 6, title: '真相边缘', date: '2025-03-17' },
    ],
    tags: ['悬疑', '推理', '犯罪', '反转'],
    views: 540000,
    updateDate: '2025-03-17',
  },
  {
    id: 7,
    title: '他的温度',
    author: '尹多温',
    category: 'bl',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20BL%20Korean%20webtoon%20illustration%20of%20two%20handsome%20young%20men%20sharing%20a%20tender%20moment%2C%20soft%20autumn%20color%20palette%2C%20warm%20and%20intimate%20atmosphere%2C%20gentle%20emotional%20portrait%20style%2C%20clean%20modern%20manhwa%20art%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 4.8,
    status: '完结',
    description: '两个完全不同温度的男人相遇了。一个是冷漠如冰的企业高管，一个是温暖如春的花店老板。在命运的安排下，他们的世界开始交织。一个关于治愈与爱的故事，让人感受到最温柔的情感力量。',
    chapters: [
      { number: 1, title: '初次相遇', date: '2024-09-01' },
      { number: 2, title: '花与冰', date: '2024-09-08' },
      { number: 3, title: '逐渐靠近', date: '2024-09-15' },
      { number: 4, title: '意外同居', date: '2024-09-22' },
      { number: 5, title: '心跳', date: '2024-09-29' },
      { number: 6, title: '告白', date: '2024-10-06' },
      { number: 7, title: '在一起的时光', date: '2024-10-13' },
      { number: 8, title: '永远的温度', date: '2024-10-20' },
    ],
    tags: ['BL', '恋爱', '治愈', '都市'],
    views: 980000,
    updateDate: '2024-10-20',
  },
  {
    id: 8,
    title: '她与她的故事',
    author: '韩素利',
    category: 'gl',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20GL%20Korean%20webtoon%20illustration%20of%20two%20beautiful%20young%20women%20looking%20at%20each%20other%20tenderly%2C%20soft%20pastel%20color%20palette%2C%20gentle%20spring%20atmosphere%2C%20emotional%20connection%2C%20clean%20elegant%20manhwa%20art%20style%2C%20simple%20dreamy%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 4.7,
    status: '连载中',
    description: '大学生活中，两个性格迥异的女孩因为一次偶然的图书馆相遇，开启了一段不同寻常的友谊，而后慢慢变成了更深的情感。这部漫画以细腻的笔触描绘了青春期的迷茫、成长和爱。',
    chapters: [
      { number: 1, title: '图书馆的邂逅', date: '2025-03-05' },
      { number: 2, title: '相同的课程', date: '2025-03-12' },
      { number: 3, title: '咖啡店约会', date: '2025-03-19' },
      { number: 4, title: '心动的信号', date: '2025-03-26' },
      { number: 5, title: '朋友的疑惑', date: '2025-04-02' },
    ],
    tags: ['GL', '恋爱', '校园', '青春'],
    views: 450000,
    updateDate: '2025-04-02',
  },
  {
    id: 9,
    title: '重生之商业帝国',
    author: '赵东山',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20webtoon%20illustration%20of%20a%20confident%20businessman%20in%20a%20luxury%20office%20with%20cityscape%20view%2C%20modern%20sleek%20art%20style%2C%20professional%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20success%20and%20ambition%20theme%2C%20clean%20manhwa%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 4.6,
    status: '连载中',
    description: '商场精英韩建国在人生最低谷时意外重生回到了二十年前。带着前世的记忆和经验，他决心打造一个前所未有的商业帝国。商场如战场，步步为营，每一集都让人热血沸腾。',
    chapters: [
      { number: 1, title: '重生1998', date: '2025-01-01' },
      { number: 2, title: '第一桶金', date: '2025-01-08' },
      { number: 3, title: '商海初战', date: '2025-01-15' },
      { number: 4, title: '危机来临', date: '2025-01-22' },
      { number: 5, title: '绝地反击', date: '2025-01-29' },
      { number: 6, title: '商业帝国', date: '2025-02-05' },
    ],
    tags: ['剧情', '重生', '商业', '励志'],
    views: 820000,
    updateDate: '2025-02-05',
  },
  {
    id: 10,
    title: '暗夜的呼唤',
    author: '吴暗夜',
    category: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20webtoon%20illustration%20with%20a%20mysterious%20shadowy%20figure%20in%20a%20dark%20hallway%2C%20creepy%20atmosphere%2C%20dim%20flickering%20light%2C%20chilling%20and%20tense%20mood%2C%20detailed%20horror%20manhwa%20art%20with%20dark%20color%20palette%2C%20eerie%20and%20unsettling%20visuals&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 4.3,
    status: '连载中',
    description: '搬进便宜公寓的大学生开始经历一系列无法解释的恐怖事件。走廊里传来的脚步声，镜子里一闪而过的影子，深夜里的低声呢喃...是幻觉还是真实存在的超自然力量？',
    chapters: [
      { number: 1, title: '新公寓', date: '2025-02-14' },
      { number: 2, title: '隔壁的房间', date: '2025-02-21' },
      { number: 3, title: '镜子里的脸', date: '2025-02-28' },
      { number: 4, title: '不应该存在的楼层', date: '2025-03-07' },
      { number: 5, title: '寻找真相', date: '2025-03-14' },
    ],
    tags: ['恐怖', '灵异', '悬疑', '惊悚'],
    views: 380000,
    updateDate: '2025-03-14',
  },
  {
    id: 11,
    title: '猫咪咖啡厅',
    author: '李温暖',
    category: 'daily',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20webtoon%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20a%20smiling%20barista%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20comforting%20atmosphere%2C%20soft%20pastel%20colors%2C%20healing%20and%20peaceful%20mood%2C%20clean%20manhwa%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 4.5,
    status: '连载中',
    description: '辞去高压工作后，女主角在城市一角开了一家猫咪咖啡厅。在这里，她遇到了各种各样的人和猫，每一个故事都温暖治愈。如果你也感到疲惫，不妨来这里坐坐。',
    chapters: [
      { number: 1, title: '辞职的那天', date: '2025-03-10' },
      { number: 2, title: '第一只猫', date: '2025-03-17' },
      { number: 3, title: '第一位客人', date: '2025-03-24' },
      { number: 4, title: '雨天来客', date: '2025-03-31' },
      { number: 5, title: '新的家人', date: '2025-04-07' },
    ],
    tags: ['日常', '治愈', '猫咪', '暖心'],
    views: 560000,
    updateDate: '2025-04-07',
  },
  {
    id: 12,
    title: '剑道少女',
    author: '张武道',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20webtoon%20illustration%20of%20a%20female%20swordfighter%20in%20mid%20action%20pose%2C%20flowing%20hair%20and%20traditional%20uniform%2C%20dramatic%20motion%20effect%2C%20strong%20martial%20arts%20atmosphere%2C%20clean%20and%20sharp%20manhwa%20art%20with%20warm%20earthy%20tones&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 4.4,
    status: '完结',
    description: '在男生为主的剑道部里，一个女孩用实力证明了一切。她不仅挑战了传统的性别偏见，更在全国剑道大赛上一路过关斩将。这是一部关于青春、热血和不屈精神的励志漫画。',
    chapters: [
      { number: 1, title: '入学剑道部', date: '2024-06-01' },
      { number: 2, title: '第一次对决', date: '2024-06-08' },
      { number: 3, title: '特训的日子', date: '2024-06-15' },
      { number: 4, title: '地区预选赛', date: '2024-06-22' },
      { number: 5, title: '强敌出现', date: '2024-06-29' },
      { number: 6, title: '全国大赛', date: '2024-07-06' },
      { number: 7, title: '最终对决', date: '2024-07-13' },
    ],
    tags: ['动作', '运动', '励志', '校园'],
    views: 490000,
    updateDate: '2024-07-13',
  },
];